import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { LPXv1_ABI } from "./abi/LPXv1_ABI";
import { LPXInfo } from "../api/classes/models";
import { BiMath } from "../libs/BiMath";

export class LPXInfoFromChain{
    public configs_:LPXConfig[];
    public reserves_:LPXReserves[];
}
export class LPXReserves{

    public static FromLPXInfo(pool:LPXInfo)
    {
        const r = new LPXReserves();
        r.fundReserve = BiMath.WEIToBI(pool.reserves.fundRaw);
        r.fundImgReserve = BiMath.WEIToBI(pool.reserves.fundImgRaw);
        r.anchorReserve = BiMath.WEIToBI(pool.reserves.anchorRaw);
        r.anchorImgReserve = BiMath.WEIToBI(pool.reserves.anchorImgRaw);
        return r;
    }

    public fundReserve:bigint;
    public fundImgReserve:bigint;
    public anchorReserve:bigint;
    public anchorImgReserve:bigint;
}
export class LPXShare{
    public share:bigint;
    public debt:bigint;
    public pending:bigint;
}
export class LPXShareInfo{
    public debt:bigint;
    public pending:bigint;
}
export class LPXConfig{
    public pack:bigint;
    public manager:string;
    public fundToken:bigint;
    public anchorToken:bigint;
    // public ntzIndex:string;
    // public rewardIndex:string;
    // public startRatio:string;
    // public sellRatio:string;
    public totalShares:bigint;
    // public lastStartDropTimestamp:string;
}

export class LPXConfigPack{
    public feeIndex:bigint; //bi //фии пула   //17b
    public ntzIndex:bigint; //bi //индекс разницы между ценой продажи и ценой покупки //17b
    public profitIndex:bigint; //bi //индекс какая часть от продажи уходит мейкеру, а какая уходит в резерв anchor //17b
    public managerRewardIndex:bigint; //bi //Индекс как доля (процентная) от profitIndex //17b
    public poolType:bigint; //bi //4b
}

        // uint256 pack;

        // address manager; //управляющий пулом
        // uint256 fundToken;
        // uint256 anchorToken;

        // uint256 totalShares; //Сумма всех долей 

export class LPXContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, LPXv1_ABI.GetABI(), provider);
    }



    async getPoolsByIds(poolsIds:number[]): Promise<LPXInfoFromChain>
    {
        const response = await this._call("getPoolsByIds", poolsIds);
        if (!response) return;
        const pools = response as LPXInfoFromChain;
        const result = new LPXInfoFromChain();
        result.reserves_ = [];
        result.configs_ = [];
        for(let i=0;i<pools.configs_.length;i++)
        {
            let reserve = pools.reserves_[i];
            let config = pools.configs_[i];
            const res = new LPXReserves();
            res.fundReserve = reserve.fundReserve;
            res.fundImgReserve = reserve.fundImgReserve;
            res.anchorReserve = reserve.anchorReserve;
            res.anchorImgReserve = reserve.anchorImgReserve;
            result.reserves_.push(res);
            const cfg = new LPXConfig();
            cfg.pack = config.pack;
            cfg.manager = config.manager;
            cfg.fundToken = config.fundToken;
            cfg.anchorToken = config.anchorToken;
            // cfg.ntzIndex = this._toDecimal(config.ntzIndex);
            // cfg.rewardIndex = this._toDecimal(config.rewardIndex);
            // cfg.startRatio = this._toDecimal(config.startRatio);
            // cfg.sellRatio = this._toDecimal(config.sellRatio);
            cfg.totalShares = config.totalShares;
            result.configs_.push(cfg);
        }
        return result;
    }

    async lastPoolId()
    {
        return await this._call("lastPoolId");
    }

    async shares(poolId:number, address:string): Promise<LPXShare>
    {
        const res = await this._call("shares", poolId, address);
        if (!res) return;
        const share = res as LPXShare;
        const result = new LPXShare();
        result.share = res.share;
        result.pending = res.pending;
        result.debt = res.debt;
        return result;
    }

    // async addLiquidity(poolId:number, fundValueEth:string, anchorValueEth:string): Promise<any>
    // {
        
    //     const result = await this._send('addLiquidity', poolId, this._toWei(fundValueEth), this._toWei(anchorValueEth)); 
    //     return result;
    // }

    // async removeLiquidity(poolId:number, partEth:string): Promise<any>
    // {
    //     const result = await this._send('removeLiquidity', poolId+"", this._web3.utils.toWei(partEth, "ether")); 
    //     return result;
    // }
}